import React from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import { ICONS } from '../../blocks/Cards/icons';
import CampoBusca from './CampoBusca';

// Ícone de cada seção pelo último trecho do caminho; seção sem ícone usa as
// iniciais, como o bloco de cards.
const ICONE_DA_SECAO = {
  institucional: 'building',
  'areas-de-atuacao': 'target',
  noticias: 'file-text',
  transparencia: 'eye',
  'trabalhe-na-agsus': 'briefcase',
  ouvidoria: 'message-circle',
};

const icone = ({ caminho, titulo }) =>
  ICONS[ICONE_DA_SECAO[caminho.split('/').pop()]] || (
    <span>{titulo.slice(0, 2).toUpperCase()}</span>
  );

// 404 no DS: banner, campo de busca e as seções do menu como atalhos.
const Pagina404 = ({ secoes, onBuscar }) => (
  <div className="ag-busca ag-404">
    <header className="ag-page-banner ag-page-banner--blue ag-page-banner--left">
      <span className="ag-page-banner__watermark" aria-hidden="true" />
      <div className="ag-page-banner__inner">
        <span className="ag-page-banner__eyebrow">Erro 404</span>
        <h1 className="ag-page-banner__title">Página não encontrada</h1>
        <p className="ag-page-banner__lede">
          O endereço pode ter mudado ou a página saiu do ar. Busque o assunto ou
          siga por uma das seções.
        </p>
      </div>
    </header>
    <div className="ag-busca__corpo">
      <CampoBusca onBuscar={onBuscar} />
      {secoes.length > 0 && (
        <section className="ag-cards-section ag-404__secoes">
          <h2 className="ag-cards-section__heading">Seções</h2>
          <div className="ag-cards-grid" style={{ '--ag-cols': 3 }}>
            {secoes.map((secao) => (
              <UniversalLink
                key={secao.caminho}
                href={secao.caminho}
                className="ag-card-icon"
              >
                <div className="ag-card-icon__circle" aria-hidden="true">
                  {icone(secao)}
                </div>
                <div className="ag-card-icon__body">
                  <h3 className="ag-card-icon__title">{secao.titulo}</h3>
                  {secao.descricao && <p>{secao.descricao}</p>}
                  <span className="ag-card-icon__cta">Acessar →</span>
                </div>
              </UniversalLink>
            ))}
          </div>
        </section>
      )}
    </div>
  </div>
);

Pagina404.propTypes = {
  secoes: PropTypes.arrayOf(
    PropTypes.shape({
      caminho: PropTypes.string.isRequired,
      titulo: PropTypes.string.isRequired,
      descricao: PropTypes.string,
    }),
  ),
  onBuscar: PropTypes.func.isRequired,
};

Pagina404.defaultProps = { secoes: [] };

export default Pagina404;
